import * as entryLayouts from "@/views/person/layout.js";
import { SiteConfig } from "@/types/siteConfig.ts";

export interface LayoutOption {
  title: string;
  desc: string;
  name: string;
  img: string;
  fetchCategoriesData?: boolean;
  fetchCategoryData?: boolean;
  fields: {
    /*
      fields can either be assigned a boolean or a function that returns
      a boolean for complex field filtering.
    */
    [key: string]: boolean | ((siteConfig: SiteConfig) => boolean);
  };
  beta?: boolean;
}

export interface LayoutConfig {
  [key: string]: LayoutOption[];
}

export const HOME_LAYOUTS: LayoutConfig = {
  Layouts: [
    {
      title: "Classic",
      desc: "",
      name: "HomeLayout1",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Classic.jpg",
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: false,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: true,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: true,
        personStripeTextColor: false,
        startColor: true,
        homeDescription: false,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: false,
      },
    },
    {
      title: "Logo Spotlight",
      desc: "",
      name: "HomeLayout3",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Logo-Spotlight.jpg",
      fields: {
        headerType: false,
        editAnnouncements: false,
        carouselCategoryIds: false,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: true,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: true,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType !== "Header1",
        titleColor: false,
        homeButtonsColor: true,
        personStripeTextColor: false,
        startColor: true,
        homeDescription: true,
        homeBlur: false,
        gridCategoryId: false,
      },
    },
    {
      title: "Carousel",
      desc: "",
      name: "HomeLayout2",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Carousel.jpg",
      fetchCategoryData: true,
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: true,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: true,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: false,
        personStripeTextColor: false,
        startColor: false,
        homeDescription: false,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: false,
      },
    },
    {
      title: "Carousel 2",
      desc: "",
      name: "HomeLayout9",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Carousel-2.jpg",
      fetchCategoryData: true,
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: true,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: true,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: false,
        personStripeTextColor: true,
        startColor: true,
        homeDescription: false,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: false,
      },
    },
    {
      title: "Scrolling Folders",
      desc: "",
      name: "HomeLayout5",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Scrolling-Folders.jpg",
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: false,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: false,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: false,
        personStripeTextColor: false,
        startColor: false,
        homeDescription: false,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: false,
      },
    },
    {
      title: "Static Folders",
      desc: "",
      name: "HomeLayout7",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Static-Folders.jpg",
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: false,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: false,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: true,
        personStripeTextColor: false,
        startColor: false,
        homeDescription: false,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: false,
      },
    },
    {
      title: "Static Pill Folders",
      desc: "",
      name: "HomeLayout6",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Static-Pill-Folders.jpg",
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: false,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: false,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: true,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: true,
        personStripeTextColor: false,
        startColor: false,
        homeDescription: false,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: false,
      },
    },
    {
      title: "Announcements",
      desc: "",
      name: "AnnouncementsLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Announcements.jpg",
      fields: {
        headerType: true,
        editAnnouncements: true,
        carouselCategoryIds: false,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: true,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: false,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: false,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: true,
        personStripeTextColor: false,
        startColor: true,
        homeDescription: false,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: false,
      },
    },
    {
      title: "Five Column Layout",
      desc: "",
      name: "FiveColumnHomeLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-5-Col-Cards.jpg",
      beta: true,
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: false,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: false,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: false,
        homeDescription: false,
        personStripeTextColor: true,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: true,
      },
    },
    {
      title: "Split Screen Spotlight",
      desc: "",
      name: "SplitScreenSpotlight",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-Split-Screen.jpg",
      beta: true,
      fields: {
        headerType: true,
        editAnnouncements: false,
        carouselCategoryIds: true,
        sponsorStyle: true,
        showLogo: true,
        showTitle: true,
        title: true,
        startButtonText: true,
        sponsorText: (siteConfig) =>
          siteConfig.Home?.styling.dropdown.sponsorStyle !== "none",
        homeDescriptionFontSize: false,
        editMedia: true,
        backgroundImage: true,
        primaryLogo: true,
        sponsorImages: true,
        presentingSponsorImages: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        homeGradient: true,
        backgroundSlideshowKenBurns: true,
        sparkleAnimation: true,
        enableCustomColors: true,
        pillCategoryTextColor: false,
        headerStripeColor: true,
        titleColor: true,
        homeButtonsColor: false,
        homeDescription: false,
        personStripeTextColor: true,
        homeBlur: (siteConfig) =>
          siteConfig.Home?.styling.header.headerType === "Header1",
        gridCategoryId: true,
      },
    },
  ],
};

export const CATEGORIES_LAYOUTS: LayoutConfig = {
  Layouts: [
    {
      title: "Logo Cards",
      desc: "",
      name: "CategoriesCardLayout3",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Categories-Logo-Cards.jpg",
      fields: {
        siteNavigationDefaultOpen: true,
        showFooterQR: true,
        hideFolderCardNames: false,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoriesGradient: true,
        enableCustomColors: true,
        categoryLogoCardBackground: true,
        categoryLogoCardHeaderColor: true,
        categoryLogoCardStripe: true,
        categoryLogoCardText: true,
        categoryTextColor: false,
        pillCategoryTextColor: false,
        background: true,
        backgroundImage: true,
        backgroundColor: (siteConfig) =>
          !siteConfig.Home?.styling.photo.backgroundImage?.[0]?.url,
      },
    },
    {
      title: "Photo Cards (Center Text)",
      desc: "",
      name: "CategoriesCardLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Categories-Photo-Cards-Centered-Text.jpg",
      fields: {
        siteNavigationDefaultOpen: true,
        showFooterQR: true,
        hideFolderCardNames: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoriesGradient: true,
        enableCustomColors: true,
        categoryLogoCardBackground: false,
        categoryLogoCardHeaderColor: false,
        categoryLogoCardStripe: false,
        categoryTextColor: true,
        pillCategoryTextColor: false,
        background: true,
        backgroundImage: true,
        backgroundColor: (siteConfig) =>
          !siteConfig.Home?.styling.photo.backgroundImage?.[0]?.url,
      },
    },
    // For CSC, I switched CategoriesCardLayout2 and CategoriesCardLayout4 since they wanted the look of 4 but 4 doesnt exist in the current app
    // @todo We probably want to switch these two right before we go live so that most sites will have a more similar look to their current site
    {
      title: "Photo Cards (Bottom Text)",
      desc: "",
      name: "CategoriesCardLayout4",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Categories-Photo-Cards-Bottom-Text.jpg",
      fields: {
        siteNavigationDefaultOpen: true,
        showFooterQR: true,
        hideFolderCardNames: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoriesGradient: true,
        enableCustomColors: true,
        categoryLogoCardBackground: false,
        categoryLogoCardHeaderColor: false,
        categoryLogoCardStripe: false,
        categoryTextColor: true,
        pillCategoryTextColor: false,
        background: true,
        backgroundImage: true,
        backgroundColor: (siteConfig) =>
          !siteConfig.Home?.styling.photo.backgroundImage?.[0]?.url,
      },
    },
    {
      title: "Photo Cards Fade",
      desc: "",
      name: "CategoriesCardLayout2",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Categories-Photo-Cards-Fade.jpg",
      fields: {
        siteNavigationDefaultOpen: true,
        showFooterQR: true,
        hideFolderCardNames: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoriesGradient: true,
        enableCustomColors: true,
        categoryLogoCardBackground: false,
        categoryLogoCardHeaderColor: false,
        categoryLogoCardStripe: false,
        categoryTextColor: false,
        pillCategoryTextColor: false,
        background: true,
        backgroundImage: true,
        backgroundColor: (siteConfig) =>
          !siteConfig.Home?.styling.photo.backgroundImage?.[0]?.url,
      },
    },
    {
      title: "Pill Cards",
      desc: "",
      name: "CategoriesPillLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Categories-Pill-Cards.jpg",
      fields: {
        siteNavigationDefaultOpen: true,
        showFooterQR: true,
        hideFolderCardNames: false,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoriesGradient: true,
        enableCustomColors: true,
        categoryLogoCardBackground: false,
        categoryLogoCardHeaderColor: false,
        categoryLogoCardStripe: false,
        categoryTextColor: false,
        pillCategoryTextColor: true,
        background: true,
        backgroundImage: true,
        backgroundColor: (siteConfig) =>
          !siteConfig.Home?.styling.photo.backgroundImage?.[0]?.url,
      },
    },
  ],
};

export const CATEGORY_LAYOUTS: LayoutConfig = {
  Layouts: [
    {
      title: "Classic Fade",
      desc: "",
      name: "PersonRectangleCardCategoryLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Classic-Fade.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: false,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: false,
      },
    },
    {
      title: "Classic Color",
      desc: "",
      name: "FourColumnLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Classic.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
      },
    },
    {
      title: "Wide Images",
      desc: "",
      name: "ThreeColumnLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Wide-Images.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
      },
    },
    {
      title: "Name Plates",
      desc: "",
      name: "PersonListCategoryLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Name-Plates.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: false,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
      },
    },
    {
      title: "List",
      desc: "",
      name: "PersonListCategoryLayout2",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-List.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: false,
        slideshowVideoAlternativeName: false,
        categoryDescription: true,
        genericImage: false,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: false,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
      },
    },
    {
      title: "Circle",
      desc: "",
      name: "PersonCircleCardCategoryLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Circle.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: false,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
      },
    },
    {
      title: "Circle Fade",
      desc: "",
      name: "CircleFadeCategoryLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Circle-Fade.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: false,
        enableCustomColors: false,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: false,
      },
    },
    {
      title: "Timeline",
      desc: "",
      name: "PersonTimelineCategoryLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Timeline.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: false,
        slideshowVideoAlternativeName: false,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
      },
    },
    {
      title: "Banners",
      desc: "",
      name: "PersonBannersLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Banners.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: false,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: false,
        graduationDateAlternativeName: false,
        activityAlternativeName: false,
        typeAlternativeName: false,
        slideshowImage1AlternativeName: false,
        slideshowVideoAlternativeName: false,
        categoryDescription: true,
        genericImage: false,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: true,
        bannerBodyBackgroundColor: true,
        bannerBodyTextColor: true,
        bannerHeaderBackgroundColor: true,
        bannerStripeColor: true,
        bannerTitleColor: true,
        personStripeTextColor: false,
      },
    },
    {
      title: "Record Columns",
      desc: "",
      name: "RecordsColumnsLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Record-Columns.jpg",
      fields: {
        addRecordCollection: true,
        attributesCategories: false,
        orderingAttribute: false,
        sortDescending: false,
        dateFormat: false,
        categoryName: true,
        eventDateAlternativeName: false,
        graduationDateAlternativeName: false,
        activityAlternativeName: false,
        typeAlternativeName: false,
        slideshowImage1AlternativeName: false,
        slideshowVideoAlternativeName: false,
        categoryDescription: true,
        genericImage: false,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: false,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: false,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: false,
      },
    },
    {
      title: "Record Rows",
      desc: "",
      name: "RecordsRowsLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Record-Rows.jpg",
      fields: {
        addRecordCollection: true,
        attributesCategories: false,
        orderingAttribute: false,
        sortDescending: false,
        dateFormat: false,
        categoryName: true,
        eventDateAlternativeName: false,
        graduationDateAlternativeName: false,
        activityAlternativeName: false,
        typeAlternativeName: false,
        slideshowImage1AlternativeName: false,
        slideshowVideoAlternativeName: false,
        categoryDescription: true,
        genericImage: false,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: false,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: false,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: false,
      },
    },
    {
      title: "Carousel",
      desc: "",
      name: "CategoryCarousel",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Category-Carousel.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: true,
        orderingAttribute: true,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: true,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: false,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: true,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
      },
    },
    {
      title: "Five Column Layout",
      desc: "",
      name: "FiveColumnLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Home-5-Col-Cards.jpg",
      fields: {
        addFolder: true,
        addProfile: true,
        addRecordCollection: false,
        attributesCategories: false,
        orderingAttribute: false,
        sortDescending: true,
        showNavigationButtons: true,
        dateFormat: false,
        categoryName: true,
        eventDateAlternativeName: true,
        graduationDateAlternativeName: true,
        activityAlternativeName: true,
        typeAlternativeName: true,
        slideshowImage1AlternativeName: true,
        slideshowVideoAlternativeName: true,
        categoryDescription: true,
        genericImage: true,
        background: true,
        cardBackground: true,
        defaultPersonCardBackground: true,
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        categoryGradient: false,
        enableCustomColors: true,
        bannerBodyBackgroundColor: false,
        bannerBodyTextColor: false,
        bannerHeaderBackgroundColor: false,
        bannerStripeColor: false,
        bannerTitleColor: false,
        personStripeTextColor: true,
        hideFolderCardNames: true,
      },
    },
  ],
};

function hideCardBackgroundForNonCardCategory(siteConfig: SiteConfig): boolean {
  return [
    "PersonListCategoryLayout",
    "PersonListCategoryLayout2",
    "PersonBannersLayout",
  ].includes(siteConfig?.Category?.page.layout.layout as string);
}

function hideGalleryToggleIfNoMedia(siteConfig: SiteConfig): boolean {
  return !siteConfig?.Person?.page.media.media?.length;
}

export const ENTRY_LAYOUTS: LayoutConfig = {
  "Dynamic Layouts": [
    {
      title: "Automagic",
      desc: "",
      name: entryLayouts.DYNAMIC_ENTRY_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/AutoMagic-Thumbnail.jpg",
      beta: true,
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: (siteConfig) =>
          !hideGalleryToggleIfNoMedia(siteConfig),
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: true,
        iframeSheetName: true,
        slideshowMedia: true,
        flipbookMedia: true,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
  ],
  "Non-Video Layouts": [
    {
      title: "Classic Light",
      desc: "",
      name: entryLayouts.ENTRY_LAYOUT_1,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Classic-Light.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Classic Light 2",
      desc: "",
      name: entryLayouts.ENTRY_LAYOUT_2,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Classic-Light-2.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Headshot",
      desc: "",
      name: entryLayouts.ENTRY_LAYOUT_3,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Headshot.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Classic Dark",
      desc: "",
      name: entryLayouts.ENTRY_LAYOUT_4,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Classic-Dark.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Headshot + Bio",
      desc: "",
      name: entryLayouts.ENTRY_LAYOUT_5,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Headshot-Bio.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: true,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Image",
      desc: "",
      name: entryLayouts.JUST_PHOTO_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Image.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Image + Title",
      desc: "",
      name: entryLayouts.PHOTO_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Image-Title.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Image + Title + Bio",
      desc: "",
      name: entryLayouts.HALF_DESCRIPTION_HALF_PHOTO_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Image-Title-Bio.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Image + Title + Stats",
      desc: "",
      name: entryLayouts.PHOTO_AND_ATTRIBUTES_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Image-Title-Stats.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Bio",
      desc: "",
      name: entryLayouts.ALL_TEXT_NO_PHOTO_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Bio.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
  ],
  "Slideshow/Video Layouts": [
    {
      title: "Landscape Slideshow",
      desc: "",
      name: entryLayouts.FULL_CONTENT_LAYOUT_LANDSCAPE,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Landscape-Slideshow.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: (siteConfig) =>
          !hideGalleryToggleIfNoMedia(siteConfig),
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: true,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Portrait Slideshow",
      desc: "",
      name: entryLayouts.FULL_CONTENT_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Portrait-Slideshow.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: (siteConfig) =>
          !hideGalleryToggleIfNoMedia(siteConfig),
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: true,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Portrait Dark Slideshow",
      desc: "",
      name: entryLayouts.FULL_CONTENT_LAYOUT_2,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Slideshow-Portrait-Dark.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: (siteConfig) =>
          !hideGalleryToggleIfNoMedia(siteConfig),
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: true,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Fullpage Slideshow",
      desc: "",
      name: entryLayouts.SLIDESHOW_AND_TITLE_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Fullpage-Slideshow.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: (siteConfig) =>
          !hideGalleryToggleIfNoMedia(siteConfig),
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: true,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: false,
        titleColor: true,
      },
    },
    {
      title: "Slideshow + Bio",
      desc: "",
      name: "DescriptionAndMediaLayout",
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Slideshow-Bio.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: (siteConfig) =>
          !hideGalleryToggleIfNoMedia(siteConfig),
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: true,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
  ],
  "Embedded Website Layouts (URL input found in text tab)": [
    {
      title: "Embedded Website",
      desc: "",
      name: entryLayouts.IFRAME_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Embed.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: true,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
    {
      title: "Embedded Google Sheet",
      desc: "",
      name: entryLayouts.IFRAME_SHEET_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Embed.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: false,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: true,
        iframeSheetName: true,
        slideshowMedia: false,
        flipbookMedia: false,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: false,
        enableCustomColors: true,
        titleColor: true,
      },
    },
  ],
  "Yearbook Layout": [
    {
      title: "Yearbook",
      desc: "",
      name: entryLayouts.FLIP_BOOK_LAYOUT,
      img: "https://prod.media.rocketalumnisolutions.com/LayoutImagesV2/Profile-Yearbooks.jpg",
      fields: {
        layout: true,
        eventDate: true,
        useSlideshowForPdf: true,
        showSlideshowAsGallery: false,
        graduationDate: true,
        firstName: true,
        lastName: true,
        activity: true,
        type: true,
        description: true,
        iframeLayoutURL: false,
        iframeSheetName: false,
        slideshowMedia: false,
        flipbookMedia: true,
        headshot: true,
        background: true,
        cardBackground: (siteConfig) =>
          !hideCardBackgroundForNonCardCategory(siteConfig),
        primaryColor: true,
        confettiAnimation: true,
        primaryColorDark: true,
        primaryColorLight: true,
        entryGradient: true,
        enableCustomColors: true,
        titleColor: true,
      },
    },
  ],
};

/*
Used for field whitelisting.
 */
const ENTRY_CARD_PREVIEW_CONFIG: LayoutOption[] = [
  {
    title: "Name Plates",
    desc: "",
    name: "PersonListCategoryLayoutCardPreview",
    img: "",
    fields: {
      layout: false,
      eventDate: true,
      useSlideshowForPdf: false,
      showSlideshowAsGallery: false,
      graduationDate: true,
      firstName: true,
      lastName: true,
      activity: true,
      type: true,
      description: true,
      iframeLayoutURL: false,
      iframeSheetName: false,
      slideshowMedia: true,
      flipbookMedia: false,
      headshot: true,
      background: false,
      cardBackground: (siteConfig) =>
        !hideCardBackgroundForNonCardCategory(siteConfig),
      primaryColor: true,
      confettiAnimation: true,
      primaryColorDark: true,
      primaryColorLight: true,
      entryGradient: false,
      enableCustomColors: true,
      titleColor: true,
    },
  },
  {
    title: "List",
    desc: "",
    name: "PersonListCategoryLayout2CardPreview",
    img: "",
    fields: {
      layout: false,
      eventDate: true,
      useSlideshowForPdf: false,
      showSlideshowAsGallery: false,
      graduationDate: true,
      firstName: true,
      lastName: true,
      activity: true,
      type: true,
      description: false,
      iframeLayoutURL: false,
      iframeSheetName: false,
      slideshowMedia: false,
      flipbookMedia: false,
      headshot: false,
      background: false,
      cardBackground: (siteConfig) =>
        !hideCardBackgroundForNonCardCategory(siteConfig),
      primaryColor: true,
      confettiAnimation: true,
      primaryColorDark: true,
      primaryColorLight: true,
      entryGradient: false,
      enableCustomColors: true,
      titleColor: true,
    },
  },
  {
    title: "Banners",
    desc: "",
    name: "PersonBannersLayoutCardPreview",
    img: "",
    fields: {
      layout: false,
      eventDate: false,
      useSlideshowForPdf: false,
      showSlideshowAsGallery: false,
      graduationDate: false,
      firstName: true,
      lastName: true,
      activity: false,
      type: false,
      description: true,
      iframeLayoutURL: false,
      iframeSheetName: false,
      slideshowMedia: false,
      flipbookMedia: false,
      headshot: true,
      background: false,
      cardBackground: (siteConfig) =>
        !hideCardBackgroundForNonCardCategory(siteConfig),
      primaryColor: true,
      confettiAnimation: true,
      primaryColorDark: true,
      primaryColorLight: true,
      entryGradient: false,
      enableCustomColors: true,
      titleColor: true,
    },
  },
];

export const FLATTENED_ENTRY_LAYOUTS: LayoutOption[] =
  Object.values(ENTRY_LAYOUTS).flat();

export const FLATTENED_ALL_LAYOUTS: LayoutOption[] = [
  ...HOME_LAYOUTS.Layouts,
  ...CATEGORIES_LAYOUTS.Layouts,
  ...CATEGORY_LAYOUTS.Layouts,
  ...FLATTENED_ENTRY_LAYOUTS,
];

export function getLayoutByName(layoutName: string): LayoutOption | undefined {
  return [...FLATTENED_ALL_LAYOUTS, ...ENTRY_CARD_PREVIEW_CONFIG].find(
    (l) => l.name === layoutName
  );
}

export function getWhitelistedFields(
  layoutName: string,
  siteConfig: SiteConfig
): string[] {
  const layout = getLayoutByName(layoutName);

  if (layout === undefined || layout.fields === undefined) {
    return [];
  }

  return Object.keys(layout.fields).filter((field) => {
    if (typeof layout.fields![field] === "boolean") {
      return layout.fields![field];
    }
    return layout.fields![field](siteConfig);
  });
}

export function getLayoutVarNameFromRouteName(routeName: string): string {
  return (
    new Map([
      ["Categories", "categoriesLayout"],
      ["SubCategories", "subcategoryLayout"],
    ]).get(routeName) ?? "layout"
  );
}
